export const isRightClick = (event: MouseEvent) => event.button === 2;
